import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavParams, ViewController } from 'ionic-angular';
import { CalendarButtonComponent } from '../../calendar-button/calendar-button.component';
import { TaskListButtonComponent } from '../../task-list-button/task-list-button.component';

@IonicPage()
@Component({
    selector: 'vas-nav-more',
    template: `
        <ion-list *ngIf="showButtons" class="more-buttons-picker-list">
            <ion-item *ngIf="showCalendarButton" (click)="onCalendarItemClick()">
                <div class="more-buttons-picker-list-item-content">
                    <vas-calendar-button
                        #calendarButton
                        [disabled]="true"
                        [accountId]="accountId"
                    ></vas-calendar-button>
                    <p>calendar</p>
                </div>
            </ion-item>
            <ion-item *ngIf="showTasksButton" (click)="onTasksItemClick()">
                <div class="more-buttons-picker-list-item-content">
                    <vas-task-list-button #tasksButton [disabled]="true"></vas-task-list-button>
                    <p>tasks</p>
                </div>
            </ion-item>
        </ion-list>
    `,
    styles: [`
        .more-buttons-picker-list {
            margin: 0;
        }
        .more-buttons-picker-list-item-content {
            display: flex;
            align-items: center;
        }
    `]
})
export class MoreButtonsPicker {

    showCalendarButton: boolean;
    showTasksButton: boolean;
    accountId: string;

    @ViewChild('calendarButton') calendarButton: CalendarButtonComponent;
    @ViewChild('tasksButton') tasksButton: TaskListButtonComponent;

    constructor(
        protected navParams: NavParams,
        protected viewCtrl: ViewController
    ) {
    }

    ngOnInit(): void {
        this.accountId = this.navParams.get('accountId');
        this.showCalendarButton = this.navParams.data.showCalendarButton;
        this.showTasksButton = this.navParams.data.showTasksButton;

        if (!this.showButtons) {
            this.viewCtrl.dismiss();
        }
    }

    get showButtons(): boolean {
        return this.showCalendarButton || this.showTasksButton;
    }

    onCalendarItemClick(): void {
        this.calendarButton.onClick(undefined);
    }

    onTasksItemClick(): void {
        this.tasksButton.onClick(undefined);
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/nav-bar/more-buttons-picker/more-buttons-picker.ts